import PensiveRobotSvg from '@/assets/PensiveRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp';
import DialogMobile from '@/components/dialog/DialogMobile.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { InactiveMessageProps } from '@/views/inactive/components/InactiveMessageDesktop.tsx';
import React from 'react';

const InactiveMessageMobile: React.FC<InactiveMessageProps> = ({ handleBack }) => {
  const { t } = useTranslationWithPrefix('views.errors');
  return (
    <div className="flex flex-column">
      <DialogMobile
        content={t('inactive.subMessage')}
        image={
          <img
            alt="love-robot"
            className="object-cover w-75 align-self-end"
            src={generateNonCachableImageSrc(PensiveRobotSvg)}
          />
        }
        message={t('inactive.title')}
      />
      <ButtonWithLoading onClick={handleBack}>{t('buttons.back')}</ButtonWithLoading>
    </div>
  );
};

export default InactiveMessageMobile;
